var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.224121,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#3F46AB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3343_8605",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.22412,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3343_8605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 24.2241C7.45 24.2241 6.97917 24.0283 6.5875 23.6366C6.19583 23.245 6 22.7741 6 22.2241V10.2241C6 9.67412 6.19583 9.20329 6.5875 8.81162C6.97917 8.41995 7.45 8.22412 8 8.22412H24C24.55 8.22412 25.0208 8.41995 25.4125 8.81162C25.8042 9.20329 26 9.67412 26 10.2241V22.2241C26 22.7741 25.8042 23.245 25.4125 23.6366C25.0208 24.0283 24.55 24.2241 24 24.2241H8ZM8 22.2241H24V12.2241H8V22.2241ZM12.675 17.2241L10.775 15.3241C10.575 15.1241 10.4792 14.8908 10.4875 14.6241C10.4958 14.3575 10.6 14.1241 10.8 13.9241C11 13.7408 11.2333 13.645 11.5 13.6366C11.7667 13.6283 12 13.7241 12.2 13.9241L14.8 16.5241C15 16.7241 15.1 16.9575 15.1 17.2241C15.1 17.4908 15 17.7241 14.8 17.9241L12.2 20.5241C12.0167 20.7075 11.7875 20.8033 11.5125 20.8116C11.2375 20.82 11 20.7241 10.8 20.5241C10.6167 20.3408 10.525 20.1075 10.525 19.8241C10.525 19.5408 10.6167 19.3075 10.8 19.1241L12.675 17.2241ZM17 21.2241C16.7167 21.2241 16.4792 21.1283 16.2875 20.9366C16.0958 20.745 16 20.5075 16 20.2241C16 19.9408 16.0958 19.7033 16.2875 19.5116C16.4792 19.32 16.7167 19.2241 17 19.2241H21C21.2833 19.2241 21.5208 19.32 21.7125 19.5116C21.9042 19.7033 22 19.9408 22 20.2241C22 20.5075 21.9042 20.745 21.7125 20.9366C21.5208 21.1283 21.2833 21.2241 21 21.2241H17Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaIcon);
export default __webpack_public_path__ + "static/media/SCA_icon.805aac2be3e1a4b2c033a4db745749fa.svg";
export { ForwardRef as ReactComponent };